

// import React, { useEffect, useState } from "react";
// import { NavLink } from "react-router-dom";
// import "../CSS/header.css";
// import logo from "../images/cropped_circle_image.png";
// import { FaBars, FaTimes } from "react-icons/fa";
// import axios from "axios";
// import { BASE_API_URL } from "../constant";


// const Sidebar = ({ isOpen, toggleSidebar, profileTrigger }) => {
//   const [userName, setUserName] = useState("");
//   const [userInitials, setUserInitials] = useState("");
//   const [userPhotoUrl, setUserPhotoUrl] = useState(null);
//   const [isTop100, setIsTop100] = useState(false);
//   const [rank, setRank] = useState(null);

//   useEffect(() => {
//     const storedUser = sessionStorage.getItem("userName");
//     const storedPhotoUrl = sessionStorage.getItem("userPhotoUrl");
//     const storedUserId = sessionStorage.getItem("userId");

//     if (storedUser) {
//       setUserName(storedUser);
//       const names = storedUser.split(" ");
//       const initials =
//         (names[0] ? names[0][0] : "") + (names[1] ? names[1][0] : "");
//       setUserInitials(initials.toUpperCase());
//     } else {
//       setUserName("Guest User");
//       setUserInitials("GU");
//     }

//     if (
//       storedPhotoUrl &&
//       storedPhotoUrl.includes("http") &&
//       !storedPhotoUrl.includes("dummyimage")
//     ) {
//       setUserPhotoUrl(storedPhotoUrl);
//     } else {
//       setUserPhotoUrl(null);
//     }

//     //  Fetch Top 100 badge info
//     const fetchTop100Status = async () => {
//       if (!storedUserId) return;
//       try {
//         const res = await axios.get(
//           `${BASE_API_URL}/api/top100-status/${storedUserId}`
//         );
//         if (res.data.isTop100) {
//           setIsTop100(true);
//           setRank(res.data.rank);
//         } else {
//           setIsTop100(false);
//         }
//       } catch (err) {
//         console.error("Error checking Top 100 status:", err);
//       }
//     };

//     fetchTop100Status();
//   }, [profileTrigger]);

//   return (
//     <div>
//       <div className="menu-toggle" onClick={toggleSidebar}>
//         {isOpen ? <FaTimes /> : <FaBars />}
//       </div>

//       <aside className={`sidebar ${isOpen ? "active" : ""}`}>
//         <div className="logo-container">
//           <div className="logo-icon">
//             <img
//               src={logo}
//               alt="Cinevestor Logo"
//               style={{ width: "50px", height: "50px" }}
//             />
//           </div>
//           <div className="logo-text">CINEVESTOR</div>
//         </div>

//         {/* <div className="search-container">
//           <input
//             type="text"
//             className="search-bar"
//             placeholder="Search contributions..."
//           />
//         </div> */}

//         <div className="user-profile">
//           <div className="user-avatar">
//             {userPhotoUrl ? (
//               <img
//                 src={userPhotoUrl}
//                 alt="Profile"
//                 className="profile-pic-sidebar"
//               />
//             ) : (
//               <span>{userInitials}</span>
//             )}
//           </div>
//           <h3 className="user-name">{userName}</h3>
//           {/* <div className="user-role">Premium Contributor</div> */}

//           {/*  TOP 100 BADGE */}
//           {isTop100 && (
//             <div className="user-role">
//                Top 10 Contributor
//               {rank && <span className="rank-text"> (Rank #{rank})</span>}
//             </div>
//           )}
//         </div>

//         <ul className="nav-menu">
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/dashboard" className="nav-link">
//               <i className="fas fa-chart-pie"></i>
//               Dashboard
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/transaction-history" className="nav-link">
//               <i className="fas fa-id-card-alt"></i>
//               Tran.History
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/kyc" className="nav-link">
//               <i className="fas fa-user-check"></i>
//               KYC Verification
//               <span className="notification-badge">3</span>
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/discover" className="nav-link">
//               <i className="fas fa-search"></i>
//               Discover
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/project" className="nav-link">
//               <i className="fas fa-project-diagram"></i>
//               My Projects
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/updates" className="nav-link">
//               <i className="fas fa-bell"></i>
//               Updates
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/contracts" className="nav-link">
//               <i className="fas fa-file-contract"></i>
//               Contracts
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/faq" className="nav-link">
//               <i className="fas fa-question-circle"></i>
//               FAQ
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/setting" className="nav-link">
//               <i className="fas fa-cog"></i>
//               Settings
//             </NavLink>
//           </li>
//           <li className="nav-item" onClick={toggleSidebar}>
//             <NavLink to="/login" className="nav-link">
//               <i className="fas fa-sign-out-alt"></i>
//               Logout
//             </NavLink>
//           </li>
//         </ul>
//       </aside>
//     </div>
//   );
// };

// export default Sidebar;












import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../CSS/header.css";
import logo from "../images/cropped_circle_image.png";
import { FaBars, FaTimes } from "react-icons/fa";
import axios from "axios";
import { BASE_API_URL } from "../constants";

const Sidebar = ({ isOpen, toggleSidebar, profileTrigger }) => {
  const [userName, setUserName] = useState("");
  const [userInitials, setUserInitials] = useState("");
  const [userPhotoUrl, setUserPhotoUrl] = useState(null);
  const [isTop100, setIsTop100] = useState(false);
  const [rank, setRank] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("userName");
    const storedPhotoUrl = sessionStorage.getItem("userPhotoUrl");
    const storedUserId = sessionStorage.getItem("userId");

    if (storedUser) {
      setUserName(storedUser);
      const names = storedUser.split(" ");
      const initials =
        (names[0] ? names[0][0] : "") + (names[1] ? names[1][0] : "");
      setUserInitials(initials.toUpperCase());
    } else {
      setUserName("Guest User");
      setUserInitials("GU");
    }

    if (
	  storedPhotoUrl &&
	  !storedPhotoUrl.includes("dummyimage")
	) {
	  const finalUrl = storedPhotoUrl.startsWith("http")
	  ? storedPhotoUrl
	  : `${BASE_API_URL}${storedPhotoUrl}`;
      console.log("storedPhotoUrl =", storedPhotoUrl);
      console.log("finalUrl =", finalUrl);
	  console.log("Photo URL:", userPhotoUrl);
	  setUserPhotoUrl(finalUrl);
	} else {
	  setUserPhotoUrl(null);
	}

    //  Fetch Top 100 badge info
    const fetchTop100Status = async () => {
      if (!storedUserId) return;
      try {
        const res = await axios.get(
          `${BASE_API_URL}/api/top100-status/${storedUserId}`
        );
        if (res.data.isTop100) {
          setIsTop100(true);
          setRank(res.data.rank);
        } else {
          setIsTop100(false);
        }
      } catch (err) {
        console.error("Error checking Top 100 status:", err);
      }
    };

    fetchTop100Status();
  }, [profileTrigger]);

  return (
    <div>
      <div className="menu-toggle" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <aside className={`sidebar ${isOpen ? "active" : ""}`}>
        <div className="logo-container">
          <div className="logo-icon">
            <img
              src={logo}
              alt="Cinevestor Logo"
              style={{ width: "50px", height: "50px" }}
            />
          </div>
          <div className="logo-text">CINEVESTOR</div>
        </div>

        {/* <div className="search-container">
          <input
            type="text"
            className="search-bar"
            placeholder="Search contributions..."
          />
        </div> */}

        <div className="user-profile">
          <div className="user-avatar">
            {userPhotoUrl ? (
              <img
                src={userPhotoUrl}
                alt="Profile"
                className="profile-pic-sidebar"
				onError={(e) => {
				console.log("Image failed:", e.target.src);
			  }}
              />
            ) : (
              <span>{userInitials}</span>
            )}
          </div>
          <h3 className="user-name">{userName}</h3>
          {/* <div className="user-role">Premium Contributor</div> */}

          {/*  TOP 100 BADGE */}
          {isTop100 && (
            <div className="user-role">
              Top 10 Contributor
              {rank && <span className="rank-text"> (Rank #{rank})</span>}
            </div>
          )}
        </div>

        <ul className="nav-menu">
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/dashboard" className="nav-link">
              <i className="fas fa-chart-pie"></i>
              Dashboard
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/transaction-history" className="nav-link">
              <i className="fas fa-id-card-alt"></i>
              Tran.History
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/kyc" className="nav-link">
              <i className="fas fa-user-check"></i>
              KYC Verification
              <span className="notification-badge">3</span>
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/discover" className="nav-link">
              <i className="fas fa-search"></i>
              Discover
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/project" className="nav-link">
              <i className="fas fa-project-diagram"></i>
              My Projects
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/updates" className="nav-link">
              <i className="fas fa-bell"></i>
              Updates
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/contracts" className="nav-link">
              <i className="fas fa-file-contract"></i>
              Contracts
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/faq" className="nav-link">
              <i className="fas fa-question-circle"></i>
              FAQ
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/setting" className="nav-link">
              <i className="fas fa-cog"></i>
              Settings
            </NavLink>
          </li>
          <li className="nav-item" onClick={toggleSidebar}>
            <NavLink to="/login" className="nav-link">
              <i className="fas fa-sign-out-alt"></i>
              Logout
            </NavLink>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;
